<template>
  <div class="my_info">
    <div class="info_nav">
      <navbar
        title="我的"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        :titlecolor="'#ffffff'"
        :righttext="'订单'"
        :righticonshow="true"
        :righttextStyle="{
          color: '#ffffff',
          'font-size': '1.5rem',
          'line-height': '3.2rem',
        }"
        @goback="goBack(false)"
        @rightclick="goOrder"
      />
    </div>
    <van-row class="box">
      <van-col span="24" class="device_info">
        <p class="tit">
          我的设备（{{ equipmentNum }}台）
          <span @click="showRule">
            <img src="@/assets/accountAgent/my/rule_icon.png" />规则说明
          </span>
        </p>
        <div class="deposit_info">
          <p class="info_tit">已退还金额</p>
          <p class="info_num">￥{{ returned_amount }}</p>
        </div>
        <div class="deposit_info subsidy">
          <p class="info_tit">待退还金额</p>
          <p class="info_num">￥{{ stay_amount }}</p>
        </div>
      </van-col>
      <van-col span="24" class="my_info_content" :style="scrollBoxHeight">
        <p class="title">红包退还记录</p>
        <div class="content">
          <van-row class="no_list" v-if="list.length == 0">
            <van-col span="24">
              <img src="@/assets/accountAgent/my/no_info.png" />
            </van-col>
            <van-col span="24" class="tip">暂无数据</van-col>
          </van-row>
          <van-pull-refresh
            v-model="isLoading"
            @refresh="onRefresh"
            v-if="list.length != 0"
          >
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <van-row
                class="info_item"
                v-for="(item, index) in list"
                :key="index"
              >
                <van-col span="12" class="left">
                  <p class="p_top">退还金额</p>
                  <p>{{ item.return_date }}</p>
                </van-col>
                <van-col span="12" class="right"
                  >+{{ item.each_amount }}</van-col
                >
              </van-row>
            </van-list>
          </van-pull-refresh>
        </div>
      </van-col>
      <van-col span="24" class="button">
        <btn
          :btntext="'去认领'"
          :btnwidth="'100%'"
          :height="'4.4rem'"
          :bgcolor="'#FF5F2E'"
          :borderradius="'2.5rem'"
          :btncolor="'#fff'"
          :fontsize="'1.7rem'"
          :fontweight="500"
          @btnClick="toPurchase"
        />
      </van-col>
    </van-row>
    <van-popup v-model="ruleShow">
      <p class="tit_bg">
        <img src="@/assets/accountAgent/my/rule_title.png" />
      </p>
      <p class="title">认领规则说明</p>
      <div class="rule_content">
        <p class="con">
          欢迎您参与销巴微超设备认领合作！本须知将对销巴微超自动售货机/充电宝设备认领的合作规则加以说明与解释，请您仔细阅读全文，以便能充分的了解本项目的所有合作规则，也便于我们更好的为您服务！
        </p>
        <p class="con">
          1、您认领设备所缴纳的费用可获得等额的销巴积分，同时销巴将以红包形式分36期按月返还。红包可用于销巴生活APP内购物消费，或自行提现，提现需扣除12%的手续费（具体使用规则详见销巴生活APP内规定）。
        </p>
        <p>
          2、本业务合作中的设备所有权归销巴所有，您与销巴共同享有认领设备在合作期内的收益权。
        </p>
        <p class="con">
          3、关于自动售货机及充电宝设备的售后服务事宜，您需联系相应的生产厂商，销巴将不负责处理设备的质量问题及维修服务
        </p>
        <p class="con">
          4、本文仅作为您参与设备认领之前的规则提示，您需要与销巴另行签订正式的合作协议。
        </p>
        <p class="con">
          如您对本项目有任何问题或建议，请在工作时间联系销巴微超客服工作人员。感谢您的耐心阅读！
        </p>
      </div>
      <img
        class="close"
        @click="closePopup"
        src="@/assets/accountAgent/my/rule_close.png"
      />
    </van-popup>
  </div>
</template>
<script>
import navbar from "../accountAgent/components/nav-bar.vue";
import btn from "../accountAgent/components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/my/reback.png"),
      scrollBoxHeight: {
        height: (document.body.clientHeight - 366) / 10 + "rem",
      },
      list: [],
      loading: false,
      finished: false,
      isLoading: false,
      page: 1,
      pageSize: 10,
      allList: 11, //默认比第一页数据多1
      ruleShow: false,
      equipmentNum: 0,
      returned_amount: "0.00",
      stay_amount: "0.00",
    };
  },
  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    this.getList();
  },
  mounted() {
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
  },
  methods: {
    showRule() {
      this.ruleShow = true;
    },
    closePopup() {
      this.ruleShow = false;
    },
    getList() {
      this.$api
        .post("onorder/member/order/machine-record", {
          page: this.page,
        })
        .then((res) => {
          this.equipmentNum = res.num || 0;
          this.returned_amount = res.returned_amount || "0.00";
          this.stay_amount = res.stay_amount || "0.00";
          this.allList = res.list.total;

          if (res.list.data.length > 0) {
            for (let i in res.list.data) {
              this.list.push(res.list.data[i]);
            }
          }
          this.loading = false;
          if (this.list.length >= this.allList) {
            // 数据全部加载完成
            this.finished = true;
          }
          if (this.isLoading) {
            this.$toast("刷新成功");
            this.isLoading = false;
          }
        });
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.page++;
        this.getList();

        // 加载状态结束
        this.isLoading = false;
      }, 500);
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.list = [];
      this.getList();
    },
    goBack() {
      this.params("", "", "goBack");
    },
    goOrder() {
      this.$router.push("/equipment/order");
    },
    toPurchase() {
      this.$router.push("/equipment/select");
    },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less" scoped>
.my_info {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .van-popup--center {
    width: 27.4rem;
    // height: 44rem;
    padding: 0 1.5rem 1.5rem;
    border-radius: 0.3rem;
    overflow: visible;

    .tit_bg {
      height: 2.9rem;
      text-align: center;
      margin-bottom: 0.9rem;

      img {
        display: inline-block;
        width: 18.5rem;
        height: 2.9rem;
      }
    }

    .title {
      color: #fff;
      text-align: center;
      height: 2.9rem;
      line-height: 2.9rem;
      font-size: 1.5rem;
      font-weight: 700;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }

    .rule_content {
      color: #666;
      font-size: 1.4rem;
      line-height: 2.4rem;
      letter-spacing: 2px;
      height: 38.1rem;
      scrollbar-width: none; /* firefox */
      -ms-overflow-style: none; /* IE 10+ */
      overflow-y: scroll;

      .con_title {
        font-weight: 700;
        margin-top: 0.6rem;

        span {
          width: 0.4rem;
          height: 0.4rem;
          border-radius: 0.2rem;
          background: #fff;
          margin-right: 0.5rem;
          float: left;
          margin-top: 1rem;
        }
      }

      .con {
        line-height: 2.2rem;
      }
    }

    .rule_content::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }

    .close {
      width: 2.6rem;
      position: absolute;
      left: 12.4rem;
      bottom: -4.6rem;
    }
  }

  .info_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #f9591b;
    z-index: 3;
  }

  .box {
    padding: 10rem 1.2rem 0;
    box-sizing: border-box;
    height: 100%;
    background: url(../../assets/accountAgent/my/myBG.png) no-repeat top center;
    background-size: 100%;
    position: relative;

    .sign {
      height: 3.6rem;
      line-height: 3.6rem;
      padding: 0 1.2rem 0 2rem;
      border-radius: 0.6rem;
      background: rgba(255, 255, 255, 0.8);
      color: #f9591b;
      font-size: 1.6rem;
      text-align: left;
      margin-bottom: 1.2rem;

      span {
        float: right;
      }
    }

    .device_info {
      width: 100%;
      height: 15.6rem;
      border-radius: 0.6rem;
      background: #fff;
      color: #333;
      font-weight: 700;
      font-size: 1.6rem;
      margin-bottom: 1rem;

      .tit {
        color: #333;
        font-size: 1.6rem;
        text-align: left;
        padding: 2rem;
        height: 2.2rem;
        line-height: 2.2rem;
        border-bottom: solid 0.1rem #eeeeee;
        margin-bottom: 1.9rem;

        span {
          float: right;
          color: #999;
          font-size: 1.4rem;
          font-weight: 400;

          img {
            width: 1.6rem;
            margin-right: 0.5rem;
            vertical-align: middle;
          }
        }
      }

      .deposit_info {
        width: 50%;
        text-align: center;
        display: inline-block;
        margin-bottom: 1rem;

        .info_tit {
          color: #999;
          font-size: 1.4rem;
          height: 2rem;
          line-height: 2rem;
          margin-bottom: 0.6rem;
          font-weight: 400;
        }

        .info_num {
          color: #f9591b;
          font-size: 2.4rem;
          font-weight: 700;
        }
      }

      .subsidy {
        float: right;
        .info_num {
          color: #333;
        }
      }
    }

    .my_info_content {
      box-sizing: border-box;
      font-size: 1.4rem;
      background: #fff;
      border-radius: 0.6rem;

      .title {
        height: 5.6rem;
        line-height: 5.6rem;
        color: #333;
        font-size: 1.5rem;
        font-weight: 700;
        padding: 0 2rem;
      }

      .content {
        height: calc(100% - 5.6rem);
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        padding: 0 2rem;

        .no_list {
          text-align: center;

          img {
            width: 22.1rem;
            margin-top: 5.7rem;
          }

          .tip {
            color: #999;
            font-size: 1.5rem;
            line-height: 6rem;
          }
        }

        .info_item {
          height: 7.4rem;
          line-height: 7.4rem;
          border-bottom: solid 0.05rem #eee;

          .left {
            color: #999;
            font-size: 1.5rem;
            text-align: left;
            padding-top: 1.4rem;

            p {
              height: 2rem;
              line-height: 2rem;
            }

            .p_top {
              color: #333;
              margin-bottom: 0.6rem;
            }
          }

          .right {
            text-align: right;
            color: #333;
            font-size: 1.8rem;
            font-weight: 700;
            height: 2.6rem;
            line-height: 2.6rem;
            margin-top: 1.4rem;
          }
        }
      }
    }

    .button {
      position: absolute;
      bottom: 3.4rem;
      left: 0;
      width: 100%;
      padding: 0 1.2rem;
    }
  }
}
</style>


